import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";

import { Button, Form, Table } from "react-bootstrap";
import { getReport } from "../../../utils/apis/win3x/all_bets/all_bets";
import { Context } from "../../../utils/context";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";

const fmt = (n) => Number(n || 0).toFixed(2);

const Tables = () => {
  const { UnauthorizedLogOut } = useContext(Context);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [report, setReport] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;

  const getDataAll = async (page = currentPage) => {
    try {
      const response = await getReport(
        startDate,
        endDate,
        page,
        perPage,
        search,
      );
      setReport(response?.data?.data);
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Back to no date filter, empty search, first page.
  const handleReset = async () => {
    setStartDate("");
    setEndDate("");
    setSearch("");
    setCurrentPage(1);
    try {
      const response = await getReport("", "", 1, perPage, "");
      setReport(response?.data?.data);
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const range =
    startDate || endDate
      ? `${startDate || "..."} - ${endDate || "..."}`
      : "All";
  const rows = report?.data || [];

  const totalRow = (label, t) => (
    <tr>
      <td colSpan={5} className="text-center">
        <b>{label}</b>
      </td>
      <td>
        <b>{fmt(t?.sales_points)}</b>
      </td>
      <td>
        <b>{fmt(t?.winning_points)}</b>
      </td>
      <td>
        <b>{fmt(t?.net_points)}</b>
      </td>
    </tr>
  );

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"All User Report"} />
        <div className="search-bar-holder ">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              if (currentPage === 1) getDataAll(1);
              else setCurrentPage(1);
            }}>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5 col-holder">
                <Form.Label style={{ color: "white" }}>From</Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  max={endDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5 col-holder">
                <Form.Label style={{ color: "white" }}>To</Form.Label>
                <Form.Control
                  type="date"
                  value={endDate}
                  min={startDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5 col-holder">
                <Form.Label style={{ color: "white" }}>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Search by name"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5 col-holder">
                <Button type="submit" className="search-btn">
                  Search
                </Button>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5 col-holder">
                <Button
                  type="button"
                  className="search-btn"
                  onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>UserName</th>
                      <th>Bet Amount</th>
                      <th>Winning Amount</th>
                      <th>Net Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, index) => (
                      <tr key={r.id}>
                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                        <td>{range}</td>
                        <td>{r.name}</td>
                        <td>{r.role}</td>
                        <td>{r.username}</td>
                        <td>{fmt(r.sales_points)}</td>
                        <td>{fmt(r.winning_points)}</td>
                        <td>{fmt(r.net_points)}</td>
                      </tr>
                    ))}
                    {!rows.length && (
                      <tr>
                        <td colSpan={8} className="text-center">
                          No data found
                        </td>
                      </tr>
                    )}
                    {/* {totalRow("Player Total", report?.totals?.player)} */}
                    {totalRow("All Total", report?.totals?.all)}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={report?.current_page}
                  totalPages={report?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Tables;
